import { reloadPage } from './reload';
import { testId } from './testId';
import styles from './RouteErrorBoundary.module.css';

// BUG-054 · the words for a build that was replaced under an open tab, and the one action that helps.
//
// This is NOT "something went wrong": nothing went wrong, and nothing the reader did caused it. A newer
// version of the app is on the server and this tab is holding the previous one, whose route files are gone.
// The guard in `app/staleBuild.ts` reloads ONCE, silently; this screen is what the reader sees only if that
// reload did not help — so it says what happened, what is safe, and offers the single thing that can help.
// No stack, no reference code, and no second button: "Back to the start" would ask for the same missing
// files. The words avoid the vocabulary of the cause (no "chunk", no "module", no "bundle") — SC-5's rule
// is that a screen speaks the product's language, and "a newer version" is the true sentence in the
// reader's own words.
//
// It is rendered from TWO places, because a missing route file arrives in two different ways:
//   · `RouteErrorBoundary`, when React Router surfaces the rejected import as a route error;
//   · `App`, when the guard sees a second failure on the same build — which is the path a real static host
//     takes, where a missing `assets/route-*.js` is answered with `index.html`, the browser refuses the
//     MIME type and the router renders an empty outlet instead of throwing (rehearsed, 2026-09-25).

export const STALE_BUILD_COPY = {
  title: 'A newer version of AdOrchestrator is ready',
  text: 'This tab is still running the previous one, so the page could not open. Reload to pick up the new version — nothing you have set is lost, and your ads and your spending are not affected.',
  action: 'Reload',
} as const;

export function StaleBuildScreen() {
  return (
    <main className={styles.wrap} data-testid={testId('state', 'error', 'stale-build')}>
      <section className={styles.card} role="alert" aria-labelledby="stale-build-title">
        <h1 id="stale-build-title" className={styles.title}>
          {STALE_BUILD_COPY.title}
        </h1>
        <p className={styles.text}>{STALE_BUILD_COPY.text}</p>
        <div className={styles.actions}>
          <button
            type="button"
            className={styles.primary}
            onClick={() => reloadPage()}
            data-testid={testId('state', 'error', 'stale-build', 'reload')}
          >
            {STALE_BUILD_COPY.action}
          </button>
        </div>
      </section>
    </main>
  );
}
